/**
 * Load a YouTube playlist after scroll intersection.
 */
( function() {
	window.addEventListener(
		'load',
		function( ) {
			const observer = new IntersectionObserver( function( entries, self ) {
				entries.forEach( ( entry ) => {
					if ( entry.isIntersecting ) {
						fetchPlaylist( entry.target );
						entry.target.removeAttribute( 'aria-hidden' );
						// Disconnect IntersectionObserver after first reveal.
						self.unobserve( entry.target );
						// All playlists loaded, so disconnect.
						if ( document.querySelector( '.wp-block-beasley-blocks-ba-yt-playlist div[aria-hidden="true"]' ) === null ) {
							self.disconnect();
						}
					}
				} );
			} );

			const playlistContainers = document.querySelectorAll( '.ba-yt-playlist-holder' );
			playlistContainers.forEach( ( playlistContainer ) => {
				observer.observe( playlistContainer );
			} );

		},
		false
	);

	/**
	 * Take YouTube List item and generate Article Card HTML.
	 * @param {Object} videoObj - YouTube Video data.
	 * @param {Boolean} showDate - Show publication date?
	 * @returns HTML of Article Card.
	 */
	function generateCard( videoObj, showDate = true ) {
		const cardEl = document.createElement( 'div' );
		cardEl.className = 'entry card';
		cardEl.dataset.id = videoObj.dataid;

		// HTML temlpate for the post.
		const postContent = `
			<div class="wp-block-cover has-background has-theme-primary-background-color">
				<img class="wp-block-cover__image-background" src="${ videoObj.thumbnail }" />
			</div>
			<div class="text-content">
				<h3 class="has-large-font-size has-theme-primary-color">
					<a href="${ videoObj.link }" target="_blank">
						${ videoObj.title }
					</a>
				</h3>
				<p className="has-smaller-font-size">
					<time datetime=${ videoObj.datetime }>${ videoObj.dateFormatted }</time>
				</p>
				<p class="related-post__excerpt">
					${ videoObj.excerpt }
				</p>
				<div class="wp-block-buttons has-theme-white-color">
					<div class="wp-block-button">
						<a href="${ videoObj.link }" target="_blank"
							class="wp-block-button__link has-background has-theme-primary-background-color">
							Watch on YouTube
						</a>
					</div>
				</div>
			</div>`;

		// Put the HTML template into the postElement div.
		cardEl.innerHTML = postContent;

		return cardEl;
	}

	/**
	 * Find the .related container and loop through the data to populate it.
	 *
	 * @param {Array} data - Array of YouTube video info (JSON)
	 * @param {HTMLElement} playlistEl - Grid parent element.
	 */
	function displayRelatedPosts( data, playlistEl) {
		if ( ! Array.isArray( data ) || data.length === 0 ) {
			return displayErrorMessage( 'Error: No videos returned (may not be public).', playlistEl );
		};

		data.forEach( function( postObject, key, data ) {
			playlistEl.append( generateCard( postObject ) );
			if ( playlistEl.querySelector( '.dummy-card' ) ) {
				playlistEl.removeChild( playlistEl.querySelector( '.dummy-card:last-of-type' ) );
			}
			// If last item has been inserted but dummy cards are still visible
			if ( Object.is(data.length - 1, key) &&	playlistEl.querySelectorAll( '.dummy-card' ) ) {
				const dummyCards = playlistEl.querySelectorAll( '.dummy-card' );
				dummyCards.forEach( dummyCard => {
					dummyCard.remove();
				} );
			}
		} );
	}

	/**
	 * Format YouTube list response and assign properties for `ArticleCard`.
	 *
	 * @param {Array} data - `Items` array returned from YouTube API response.
	 * @param {Number} limit - Number of Article Cards to show.
	 * @param {String} order - Order of videos. Default is 'newest' first;
	 * @param {Number} offset - Number of Article Cards to skip.
	 * @returns {Array} Array of objects with Article Card properties.
	 */
	function formatYouTubeData( data, limit, order, offset = 0 ) {
		let cleanedData = [];
		if ( order === 'newest' ) {
			data = data.reverse();
			data = data.sort((a, b) => (
					a.contentDetails.videoPublishedAt < b.contentDetails.videoPublishedAt
				) ? 1 : -1)
		} else {
			data = data.sort((a, b) => (
				a.contentDetails.videoPublishedAt > b.contentDetails.videoPublishedAt
			) ? 1 : -1)
		}

		if ( offset && offset > 0 ) {
			data = data.splice( offset );
		}

		for (let index = 0; index < data.length; index++) {
			const videoObj = data[index];

			if ( videoObj.status.privacyStatus !== 'public' ) {
				continue; // Exit immediately if not public.
			}

			let cleanObj = {
				buttonText: 'Watch on YouTube',
				title: videoObj.snippet.title,
				excerpt: videoObj.snippet.description,
				linkTarget: '_blank',
				datetime: videoObj.contentDetails.videoPublishedAt,
				//datetime: videoObj.snippet.publishedAt,
				dataid: videoObj.snippet.resourceId.videoId,
				privacyStatus: videoObj.status.privacyStatus
			};


			/* ----- Thumbail Image ----- */
			cleanObj.thumbnail = 'https://www.beasleyallen.com/wp-content/uploads/ba-logo-ba-blue-500.png';

			if ( videoObj.snippet.thumbnails.hasOwnProperty( 'standard' ) ) {
				cleanObj.thumbnail = videoObj.snippet.thumbnails.standard.url;
			} else if ( videoObj.snippet.thumbnails.hasOwnProperty( 'high' ) ) {
				cleanObj.thumbnail = videoObj.snippet.thumbnails.high.url;
			}

			/* ----- Link to Video ----- */
			cleanObj.link = `https://youtu.be/${ videoObj.snippet.resourceId.videoId }`;
			// Note: May want to change to :
			// https://www.youtube.com/watch?v={VidID}&list={PlaylistID}

			/* ----- Formatted Date ----- */
			const dateFormat = { year: 'numeric', month: 'long', day: 'numeric' };
			cleanObj.dateFormatted = new Date( cleanObj.datetime ).toLocaleDateString( 'en-us', dateFormat );

			cleanedData.push( cleanObj ) ;
			if ( cleanedData.length >= limit ) {
				break;
			}
		} // END FOR LOOP

		return cleanedData;
	}

	/**
	 * Show message to user & log details to the console when playlist can't be shown.
	 *
	 * @param {String} errorMsg - Message for dev console output.
	 * @param {HTMLElement} playlistEl - Grid parent element.
	 */
	function displayErrorMessage( errorMsg, playlistEl ) {
		console.log( errorMsg );
		playlistEl.innerHTML = '<p><b>Something went wrong.</b> <br />' +
			'It appears this YouTube playlist is unavailable at this time. ' +
			'We apologize for the inconvenience.</p>' +
			'<div class="wp-block-buttons" style="display: flex; justify-content: center; ' +
			'margin: 1em auto; align-items: center;">' +
			'<div class="wp-block-button is-style-outline">' +
				'<a class="wp-block-button__link has-theme-white-color has-theme-' +
				'primary-background-color has-text-color has-background" target="_blank" ' +
				'href="https://www.youtube.com/c/BeasleyAllen/">Visit our YouTube Channel</a></div></div>';
		playlistEl.classList.remove( 'card-grid' );
	}

	/**
	 * Process data from YouTube.  If error, give feedback. If successful, show
	 * render card grid.
	 *
	 * @param {Object} data - Repsonse from YouTube Data API (v3)
	 * @param {HTMLElement} playlistEl - Grid parent element.
	 */
	function processYouTubeAPIRepsonse( data, playlistEl ) {
		let dataCount  = 3;
		let dataOrder  = 'newest';
		let dataOffset = 0;

		if ( playlistEl.dataset.order ) {
			dataOrder = playlistEl.dataset.order;
		}

		if ( playlistEl.dataset.count ) {
			dataCount = Number(playlistEl.dataset.count);
		}

		if ( playlistEl.dataset.offset ) {
			dataOffset = Number(playlistEl.dataset.offset);
		}

		if ( data.error ) {
			console.log( 'Error returned from YouTube API. Details below:' );
			displayErrorMessage( data.error, playlistEl );
		/* ----- Items returned; Render card grid ----- */
		} else if ( data.items ) {
			let cardData = formatYouTubeData( data.items, dataCount, dataOrder, dataOffset );


			displayRelatedPosts( cardData, playlistEl );
		/* ----- Fallback: Nothing returned ----- */
		} else {
			displayErrorMessage( 'Nothing returned from YouTube API.', playlistEl );
		}
	}

	/**
	 * Fetch playlist from YouTube's Data API (v3).
	 *
	 * @param {HTMLElement} playlistEl - Grid parent element.
	 */
	function fetchPlaylist( playlistEl ) {
		let playlistID = 'PLbzap_yCoDXu97nviOsTxOychOo5eehj4'; // Webinar playlist
		const apiKey = 'AIzaSyBSjn45Xcltn4MzuSfpjAlf7x22fun4AlU';


		if ( playlistEl ) {
			let dataPlaylist = playlistEl.getAttribute( 'data-playlist' );
			if ( dataPlaylist != null && dataPlaylist !== '' ) {
				playlistID = dataPlaylist;
			}

			let ytapi = 'https://www.googleapis.com/youtube/v3/playlistItems?playlistId=' +
			playlistID + '&key=' + apiKey +
			'&part=snippet,status,contentDetails&maxResults=50';

			const url2fetch = ytapi;

			fetch( url2fetch )
			.then( response => response.json() )
			.then( data => {
				processYouTubeAPIRepsonse( data, playlistEl );
			} );
		} else {
			console.log( 'No parent container' );
		}
	}
} )();
